import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { ArrowLeft, Tag } from "lucide-react";

export default function PurchaseGroupDetail() {
  const { group } = useParams();
  const navigate = useNavigate();
  const [data, setData] = useState({ rows: [], count: 0, total_actual_value: 0, label: "" });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    api.get(`/dashboard/purchase-groups/${encodeURIComponent(group)}/details`)
      .then((r) => setData(r.data))
      .finally(() => setLoading(false));
  }, [group]);

  return (
    <div className="space-y-6">
      <div className="flex items-end justify-between flex-wrap gap-3">
        <div>
          <button
            onClick={() => navigate("/")}
            data-testid="pg-back"
            className="text-xs text-slate-500 hover:text-slate-900 inline-flex items-center gap-1 mb-2"
          >
            <ArrowLeft size={12} /> Dashboard
          </button>
          <div className="text-[11px] uppercase tracking-widest text-slate-500">Purchase Group</div>
          <h1 className="text-2xl sm:text-3xl font-semibold tracking-tight text-slate-900 flex items-center gap-3">
            <Tag size={22} className="text-[#1D2951]" />
            {data.label || group}
          </h1>
          <p className="text-sm text-slate-500 mt-1">
            {data.count} GRN line items · Total Actual Value <span className="font-mono text-slate-900">₹{Number(data.total_actual_value || 0).toLocaleString("en-IN")}</span>
          </p>
        </div>
      </div>

      <div className="bg-white border border-slate-200 rounded-lg overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="bg-slate-50 text-xs uppercase tracking-wider text-slate-600">
                <th className="text-left px-4 py-3">GRN</th>
                <th className="text-left px-4 py-3">Date</th>
                <th className="text-left px-4 py-3">PO No.</th>
                <th className="text-left px-4 py-3">Supplier</th>
                <th className="text-left px-4 py-3">Invoice</th>
                <th className="text-left px-4 py-3">Item Code</th>
                <th className="text-left px-4 py-3">Description</th>
                <th className="text-left px-4 py-3">Category</th>
                <th className="text-right px-4 py-3">Qty</th>
                <th className="text-right px-4 py-3">Actual Value</th>
                <th className="text-right px-4 py-3">Gross Value</th>
              </tr>
            </thead>
            <tbody data-testid="pg-detail-list">
              {loading && (
                <tr><td colSpan={11} className="text-center py-12 text-slate-400">Loading…</td></tr>
              )}
              {!loading && data.rows.length === 0 && (
                <tr><td colSpan={11} className="text-center py-12 text-slate-400">No GRN data in this purchase group yet</td></tr>
              )}
              {!loading && data.rows.map((r, idx) => (
                <tr key={idx} className="border-t border-slate-100 hover:bg-slate-50">
                  <td className="px-4 py-3 font-mono text-xs font-semibold text-emerald-700">{r.grn_number || "—"}</td>
                  <td className="px-4 py-3 font-mono text-xs">{r.grn_date || "—"}</td>
                  <td className="px-4 py-3 font-mono text-xs font-semibold">{r.po_number}</td>
                  <td className="px-4 py-3">{r.supplier_name}</td>
                  <td className="px-4 py-3 font-mono text-xs">{r.invoice_number || "—"}</td>
                  <td className="px-4 py-3 font-mono text-xs">{r.item_code || "—"}</td>
                  <td className="px-4 py-3">{r.description}</td>
                  <td className="px-4 py-3">{r.category || "—"}</td>
                  <td className="px-4 py-3 text-right font-mono">{r.actual_quantity} {r.unit}</td>
                  <td className="px-4 py-3 text-right font-mono">₹{Number(r.actual_value).toLocaleString("en-IN")}</td>
                  <td className="px-4 py-3 text-right font-mono">₹{Number(r.gross_value).toLocaleString("en-IN")}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
